/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import styles from './caseUpload.module.scss';
import { ApiCore } from '../../api/index';
import caseBanner from '../../static/images_medicalLive/summary_banner2.png';
import promptImg from '../../static/images_medicalLive/prompt.png';
import caseUploadImg from '../../static/images_medicalLive/case_upload.png';
import utils from '../../utils/utils';
const api = new ApiCore();

function CaseUpload(props: any) {
    // 获取活动activityCode
    let activityCode = utils.getUrlParams().activityCode;
    // 小程序url
    const [urlScheme, setUrlScheme] = useState<any>('');
    // 活动logo
    const [logo, setLogo] = useState<any>('');

    useEffect(() => {
        document.title = '案例上传';
        getUrlScheme()
        getData()
    }, [])

    const getData = () => {
        let params = {
            activityCode: activityCode ?? 'YMTSP'
        }
        api.getProjectActivity(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                const data = res.data;
                setLogo(data.logo)
            }    
        });
    }

    /**
     * 生成小程序url scheme
     */
    const getUrlScheme = () => {
        let env = process.env.REACT_APP_ENV;
        let envVersion = 'release';
   
        // 开发环境 开发版
        if (env === 'development') {
            envVersion = 'develop';
        }
        // 测试环境 体验版
        else if (env === 'test') {
            envVersion = 'trial';
        }
        // 生产环境 正式版
        else if (env === 'production') {
            envVersion = 'release';
        }
        let params = {
            appCode: 'APP001',
            envVersion,
            path: 'pages/index/index',
            query: ''
        }
        api.getAppSecretScheme(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setUrlScheme(res.data)
            }
        });
    }

    /**
     * 案例上传
     */
    const upLoadCase = () => {
        window.location.href = urlScheme
    }

    return (
        <div className={`${styles.caseUpload_content}`}>
            <img src={logo?logo:caseBanner} alt='' className={`${styles.caseBanner}`} />
            <img src={promptImg} alt='' className={`${styles.promptImg}`} />
            <div className={`${styles.caseContent}`}>
                <div>如您希望分享案例，请点击上传</div>
                <Button type="primary" onClick={upLoadCase}>点击案例上传</Button>
                {/* <div>苹果手机请登录电脑端</div>
                <a href='#' className={`${styles.link}`}>{'http://go-case.kydev.net/dist/index.html#/'}</a>
                <div>进行案例上传</div> */}
                <img src={caseUploadImg} alt='' className={`${styles.caseUploadImg}`} />
            </div>
        </div>
    )

}

export default CaseUpload;